import * as gConst from 'services/constants';
// Constants
import { ROLES } from 'services/constants';

const FILTER_STATUS_ARRAY = [
  // 0
  {
    index: 0,
    translateLabel: 'consultation_booked',
    conditions: gConst.STATUS_BOOKED,
    defaultActive: true
  },
  // 1
  {
    index: 1,
    translateLabel: 'consultation_canceled',
    conditions: gConst.STATUS_CANCELLED,
    defaultActive: false,
    bottomLine: true
  },
  // 2 arrived
  {
    index: 2,
    translateLabel: 'arrived',
    conditions: [gConst.STATUS_ARRIVED, gConst.STATUS_SELF_ARRIVED],
    defaultActive: true
  },
  // 3 consultation_in_progress
  {
    index: 3,
    translateLabel: 'consultation_in_progress',
    conditions: [
      gConst.STATUS_STARTED,
      gConst.STATUS_CONSULTATION_RESTARTED,
      gConst.STATUS_SUSPENDED,
      gConst.STATUS_CONSULTATION_STARTED_AFTER_RADIOLOGY
    ],
    defaultActive: true
  },
  // 4 to radiology
  {
    index: 4,
    translateLabel: 'to_radiology',
    conditions: [
      gConst.STATUS_RADIOLOGY_STARTED,
      gConst.STATUS_RADIOLOGY_STARTED_DURING
    ],
    defaultActive: true
  },
  // 5 from radiology
  {
    index: 5,
    translateLabel: 'from_radiology',
    conditions: [
      gConst.STATUS_RADIOLOGY_FINISHED,
      gConst.STATUS_RADIOLOGY_FINISHED_DURING
    ],
    defaultActive: true
  },
  // 6 finished
  {
    index: 6,
    translateLabel: 'consultation_finished',
    conditions: gConst.STATUS_FINISHED,
    defaultActive: true,
    bottomLine: true
  },
  // 7 paid
  {
    index: 7,
    translateLabel: 'consultation_paid',
    conditions: gConst.STATUS_PAID,
    defaultActive: true
  },
  // 8 not show
  {
    index: 8,
    translateLabel: 'consultation_nowshow',
    conditions: gConst.STATUS_NO_SHOW,
    defaultActive: false
  }
];

const FILTER_STATUS_ARRAY_RADIOLOGY = [ 
  // 2 arrived
  {
    index: 2,
    translateLabel: 'arrived',
    conditions: [gConst.STATUS_ARRIVED, gConst.STATUS_SELF_ARRIVED],
    defaultActive: true
  },
  // 3 consultation_in_progress
  {
    index: 3,
    translateLabel: 'consultation_in_progress',
    conditions: [
      gConst.STATUS_STARTED,
      gConst.STATUS_CONSULTATION_RESTARTED,
      gConst.STATUS_SUSPENDED,
      gConst.STATUS_CONSULTATION_STARTED_AFTER_RADIOLOGY
    ],
    defaultActive: true
  },
  // 4 to radiology
  {
    index: 4,
    translateLabel: 'to_radiology',
    conditions: [
      gConst.STATUS_RADIOLOGY_STARTED,
      gConst.STATUS_RADIOLOGY_STARTED_DURING
    ],
    defaultActive: true
  },
  // 5 from radiology
  {
    index: 5,
    translateLabel: 'from_radiology',
    conditions: [
      gConst.STATUS_RADIOLOGY_FINISHED,
      gConst.STATUS_RADIOLOGY_FINISHED_DURING
    ],
    defaultActive: true
  }, 
];

export const getAppointmentViewTriggers = obj => {
  return (
    obj &&
    obj.appointment &&
    obj.appointment.triggerInfo &&
    obj.appointment.triggerInfo.triggers
  );
};

export const sortAppointmentStatusArray = (role) => {
  if (role) {
    const filterArr = role === ROLES.RADIOLOGY ? FILTER_STATUS_ARRAY_RADIOLOGY : FILTER_STATUS_ARRAY;
    return filterArr.sort(
      (a, b) => a.index && b.index && a.index - b.index
    );
  }
  return [];
};
